import React from 'react'
import moment from 'moment'
import RenderProfilePicture from '../../../_helpers/profile-picture'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

export default function Participant({ name, profileUrl, lastReadAt, hasMessages, notifications, children }) {

  const handleReadAt = () => {
    if (hasMessages === false) {
      return 'No Messages'
    }
    else if (notifications === false) {
      return 'Notifications Off'
    }
    else if (lastReadAt) {
      const now = moment().utc()
      const lastRead = moment.tz(lastReadAt.date, lastReadAt.timezone).local()

      return <div><b>Read: </b>
        {now.diff(lastRead, 'hours') > 4 ? lastRead.format('ll @ LT') : `${lastRead.toNow(true)} ago`}
      </div>
    }
    return 'Has not read messages'
  }

  return (
    <div className='row my-2'>
      <div className="col-1 my-auto">
        <OverlayTrigger
          show={true}
          placement="top"
          overlay={<Tooltip>
            Notifications {notifications ? 'On' : 'Off'}
          </Tooltip>}
        >
          <small>
            {notifications ?
              <i className="fas fa-bell text-secondary px-1"></i>
              :
              <i className="fas fa-bell-slash text-secondary"></i>
            }
          </small>
        </OverlayTrigger>
      </div>

      <div className="col-2 my-auto">
        <RenderProfilePicture
          circle
          image={profileUrl}
          width={35}
          height={35}
          cached={false}
          className='m-auto'
        />
      </div>

      <div className="col my-auto">
        <div className="row">
          <div className="col">
            {name}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <small className='text-muted'>
              {handleReadAt()}
            </small>
          </div>
        </div>
      </div>

      {children}
    </div >
  )
}
